import { render, staticRenderFns } from "./image-viewer.vue?vue&type=template&id=2defaa61&scoped=true"
import script from "./image-viewer.vue?vue&type=script&lang=js"
export * from "./image-viewer.vue?vue&type=script&lang=js"
import style0 from "./image-viewer.vue?vue&type=style&index=0&id=2defaa61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2defaa61",
  null
  
)

export default component.exports